import React from "react"

function Divider () {
  return <div className="h-[2px] bg-gray-500 rounded-md my-2 col-span-12"></div>
}

export default Divider
